import React, { Component } from 'react';
import {
  FormGroup,
  FormControl,
  ControlLabel,
  Row,
  Col,
  Grid,
  Panel,
  Table,
  Tab,
  Tabs,
  Label,
  Button,
  Tooltip,
  OverlayTrigger
} from 'react-bootstrap';
import { Prompt } from 'react-router-dom';
import LoaderButton from '../components/LoaderButton';
import './NewEstimate.css';
import { API } from 'aws-amplify';
import html2canvas from 'html2canvas';
import $ from 'jquery';
import EstimatorNavBar from '../components/EstimatorNavBar';
import FreeAccountModal from '../components/FreeAccountModal';

export default class NewEstimate extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.file = null;

    this.state = {
      /* justUpgraded: false, */
      showFreeAccountModal: false,
      key: 1,
      isLoading: null,
      estimateName: '',
      totalFTE: 1,
      //core content
      vendorObjectsS: 0,
      vendorObjectsM: 0,
      vendorObjectsC: 0,
      vendorTransformsS: 0,
      vendorTransformsM: 0,
      vendorTransformsC: 0,
      openSourceObjectsS: 0,
      openSourceObjectsM: 0,
      openSourceObjectsC: 0,
      dataSourcesS: 0,
      dataSourcesM: 0,
      dataSourcesC: 0,
      //app structure
      appsNumber: 0,
      hierarchiesNumber: 0,
      tabsNumber: 0,
      //project management
      hasManagement: 0,
      hasBASupport: 0,
      isStrategicOrPoC: 0,
      hasSIT: 0,
      hasUAT: 0,
      hasKX: 0,
      //calculated core contentvariables
      totalVendorObjectsHours: 0,
      totalVendorTransformsHours: 0,
      totalOpenSourceObjectsHours: 0,
      totalDataSourcesHours: 0,
      coreContentHours: 0,
      //calculated app structure variables
      totalAppsHours: 0,
      totalHierarchiesHours: 0,
      totalTabsHours: 0,
      appStructureHours: 0,
      //calculated project management variables
      totalManagementHours: 0,
      totalBASupportHours: 0,
      totalStrategicOrPoCHours: 0,
      totalSITHours: 0,
      totalUATHours: 0,
      totalKXHours: 0,
      //calculated totals
      totalBeforeContingencyHours: 0,
      totalContingencyHours: 0,
      overallTotalHours: 0,
      estimatedDuration: 0
    };
  }

  handleSelect(key) {
    this.setState({ key });
  }

  validateForm() {
    return (
      this.state.estimateName !== 'My New Project' &&
      this.state.estimateName.length > 0
    );
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });

    this.cleanInputs();
    //core content calcs
    this.calculate();
  };

  handleSubmit = async event => {
    event.preventDefault();

    if (this.props.accountType === 'free' /*  && !this.state.justUpgraded */) {
      /* window.onbeforeunload = function() {}; */
      this.setState({ showFreeAccountModal: true });
    } else {
      this.setState({ isLoading: true });
      try {
        await this.createEstimate({
          estimateName: this.state.estimateName,
          totalFTE: this.state.totalFTE,
          //core content
          vendorObjectsS: this.state.vendorObjectsS,
          vendorObjectsM: this.state.vendorObjectsM,
          vendorObjectsC: this.state.vendorObjectsC,
          vendorTransformsS: this.state.vendorTransformsS,
          vendorTransformsM: this.state.vendorTransformsM,
          vendorTransformsC: this.state.vendorTransformsC,
          openSourceObjectsS: this.state.openSourceObjectsS,
          openSourceObjectsM: this.state.openSourceObjectsM,
          openSourceObjectsC: this.state.openSourceObjectsC,
          dataSourcesS: this.state.dataSourcesS,
          dataSourcesM: this.state.dataSourcesM,
          dataSourcesC: this.state.dataSourcesC,
          //app structure
          appsNumber: this.state.appsNumber,
          hierarchiesNumber: this.state.hierarchiesNumber,
          tabsNumber: this.state.tabsNumber,
          //project management
          hasManagement: this.state.hasManagement,
          hasBASupport: this.state.hasBASupport,
          isStrategicOrPoC: this.state.isStrategicOrPoC,
          hasSIT: this.state.hasSIT,
          hasUAT: this.state.hasUAT,
          hasKX: this.state.hasKX
        });
        this.props.history.push('/beta');
      } catch (e) {
        alert(e);
        this.setState({ isLoading: false });
      }
    }
  };

  cleanInputs() {
    this.setState((prevState, props) => ({
      totalFTE: prevState.totalFTE === '' ? 0 : prevState.totalFTE,
      //core content
      vendorObjectsS:
        prevState.vendorObjectsS === '' ? 0 : prevState.vendorObjectsS,
      vendorObjectsM:
        prevState.vendorObjectsM === '' ? 0 : prevState.vendorObjectsM,
      vendorObjectsC:
        prevState.vendorObjectsC === '' ? 0 : prevState.vendorObjectsC,
      vendorTransformsS:
        prevState.vendorTransformsS === '' ? 0 : prevState.vendorTransformsS,
      vendorTransformsM:
        prevState.vendorTransformsM === '' ? 0 : prevState.vendorTransformsM,
      vendorTransformsC:
        prevState.vendorTransformsC === '' ? 0 : prevState.vendorTransformsC,
      openSourceObjectsS:
        prevState.openSourceObjectsS === '' ? 0 : prevState.openSourceObjectsS,
      openSourceObjectsM:
        prevState.openSourceObjectsM === '' ? 0 : prevState.openSourceObjectsM,
      openSourceObjectsC:
        prevState.openSourceObjectsC === '' ? 0 : prevState.openSourceObjectsC,
      dataSourcesS: prevState.dataSourcesS === '' ? 0 : prevState.dataSourcesS,
      dataSourcesM: prevState.dataSourcesM === '' ? 0 : prevState.dataSourcesM,
      dataSourcesC: prevState.dataSourcesC === '' ? 0 : prevState.dataSourcesC,
      //app structure
      appsNumber: prevState.appsNumber === '' ? 0 : prevState.appsNumber,
      hierarchiesNumber:
        prevState.hierarchiesNumber === '' ? 0 : prevState.hierarchiesNumber,
      tabsNumber: prevState.tabsNumber === '' ? 0 : prevState.tabsNumber,
      //project management
      hasManagement:
        prevState.hasManagement === '' ? 0 : prevState.hasManagement,
      hasBASupport: prevState.hasBASupport === '' ? 0 : prevState.hasBASupport,
      isStrategicOrPoC:
        prevState.isStrategicOrPoC === '' ? 0 : prevState.isStrategicOrPoC,
      hasSIT: prevState.hasSIT === '' ? 0 : prevState.hasSIT,
      hasUAT: prevState.hasUAT === '' ? 0 : prevState.hasUAT,
      hasKX: prevState.hasKX === '' ? 0 : prevState.hasKX
    }));
  }

  calculate() {
    this.setState((prevState, props) => ({
      totalVendorObjectsHours: Math.max(
        0,
        4 * parseInt(prevState.vendorObjectsS, 10) +
          8 * parseInt(prevState.vendorObjectsM, 10) +
          16 * parseInt(prevState.vendorObjectsC, 10)
      ),
      totalVendorTransformsHours: Math.max(
        0,
        2 * parseInt(prevState.vendorTransformsS, 10) +
          4 * parseInt(prevState.vendorTransformsM, 10) +
          6 * parseInt(prevState.vendorTransformsC, 10)
      ),
      totalOpenSourceObjectsHours: Math.max(
        0,
        8 * parseInt(prevState.openSourceObjectsS, 10) +
          40 * parseInt(prevState.openSourceObjectsM, 10) +
          80 * parseInt(prevState.openSourceObjectsC, 10)
      ),
      totalDataSourcesHours: Math.max(
        0,
        4 * parseInt(prevState.dataSourcesS, 10) +
          16 * parseInt(prevState.dataSourcesM, 10) +
          40 * parseInt(prevState.dataSourcesC, 10)
      )
    }));

    //core content total calc
    this.setState((prevState, props) => ({
      coreContentHours: Math.max(
        0,
        prevState.totalVendorObjectsHours +
          prevState.totalVendorTransformsHours +
          prevState.totalOpenSourceObjectsHours +
          prevState.totalDataSourcesHours
      )
    }));

    //app structure calcs
    this.setState((prevState, props) => ({
      totalAppsHours: Math.max(
        0,
        (1 + parseInt(prevState.appsNumber, 10) * 0.2) *
          prevState.coreContentHours
      ),
      totalHierarchiesHours: Math.max(
        0,
        (1 + parseInt(prevState.hierarchiesNumber, 10) * 0.1) *
          prevState.coreContentHours
      ),
      totalTabsHours: Math.max(
        0,
        (1 + parseInt(prevState.tabsNumber, 10) * 0.1) *
          prevState.coreContentHours
      )
    }));

    //app structure total calc
    this.setState((prevState, props) => ({
      appStructureHours: Math.max(
        0,
        prevState.totalAppsHours +
          prevState.totalHierarchiesHours +
          prevState.totalTabsHours
      )
    }));

    //project management calc
    this.setState((prevState, props) => ({
      totalManagementHours: Math.max(
        0,
        prevState.appStructureHours * prevState.hasManagement * 0.3
      ),
      totalBASupportHours: Math.max(
        0,
        prevState.appStructureHours * prevState.hasBASupport * 0.1
      ),
      totalStrategicOrPoCHours: Math.max(
        0,
        prevState.appStructureHours * prevState.isStrategicOrPoC * 0.45
      ),
      totalSITHours: Math.max(
        0,
        prevState.appStructureHours * prevState.hasSIT * 0.2
      ),
      totalUATHours: Math.max(
        0,
        prevState.appStructureHours * prevState.hasUAT * 0.1
      ),
      totalKXHours: Math.max(
        0,
        prevState.appStructureHours * prevState.hasKX * 0.1
      )
    }));

    //project management total before contingency calc
    this.setState((prevState, props) => ({
      totalBeforeContingencyHours: Math.max(
        0,
        prevState.appStructureHours +
          prevState.totalManagementHours +
          prevState.totalBASupportHours +
          prevState.totalStrategicOrPoCHours +
          prevState.totalSITHours +
          prevState.totalUATHours +
          prevState.totalKXHours
      )
    }));

    //contingency calc
    this.setState((prevState, props) => ({
      totalContingencyHours: Math.max(
        0,
        prevState.totalBeforeContingencyHours * 0.2
      )
    }));

    //total after contingency calc
    this.setState((prevState, props) => ({
      overallTotalHours: Math.max(
        0,
        prevState.totalBeforeContingencyHours + prevState.totalContingencyHours
      )
    }));

    //estimated duration (last calculation)
    this.setState((prevState, props) => ({
      estimatedDuration: Math.max(
        0,
        prevState.overallTotalHours / 8 / prevState.totalFTE / 20
      )
    }));
  }

  createEstimate(estimate) {
    return API.post('va-estimator', '/va-estimator', {
      body: estimate
    });
  }
  nextTab(e) {
    e.preventDefault();
    window.scrollTo(0, 0);
    this.setState({ key: Math.max(1, (this.state.key + 1) % 4) });
  }

  takeScreenshot(e) {
    e.preventDefault();
    const name = this.state.estimateName;
    html2canvas(document.body).then(function(canvas) {
      var a = document.getElementById('download-link');
      a.href = canvas
        .toDataURL('image/jpeg')
        .replace('image/jpeg', 'image/octet-stream');
      a.download = name + '.jpg';

      $('#download-link').css('visibility', 'visible');
    });
  }

  hideDownloadButton(e) {
    $('#download-link').css('visibility', 'hidden');
  }

  render() {
    const tooltipkpi = (
      <Tooltip id="tooltip-kpi">Key Performance Indicators</Tooltip>
    );

    const tooltipodag = (
      <Tooltip id="tooltip-odag">On-Demand App Generation</Tooltip>
    );

    const tooltipjslibs = (
      <Tooltip id="tooltip-jslibs">
        D3.JS, Chart.JS and HighCharts are JavaScript libraries that facilitate
        the creation of custom data visualisations.
      </Tooltip>
    );

    const tooltipapi = (
      <Tooltip id="tooltip-api">
        APIs (Application Programming Interface) allow applications to
        communicate with other applications easily.
      </Tooltip>
    );

    const tooltipetl = (
      <Tooltip id="tooltip-etl">
        Extract, Transform and Load is the process of extracting data from data
        sources, enforcing data quality standards and delivering it into a
        format appropriate for the end application.
      </Tooltip>
    );

    const tooltipfte = (
      <Tooltip id="tooltip-fte">Full-Time Employees on this project.</Tooltip>
    );

    const tooltipba = <Tooltip id="tooltip-ba">Business Analyst</Tooltip>;

    const tooltipsit = (
      <Tooltip id="tooltip-sit">System Integration Testing</Tooltip>
    );

    const tooltipuat = (
      <Tooltip id="tooltip-uat">User Acceptance Testing</Tooltip>
    );

    const tooltipsvg = (
      <Tooltip id="tooltip-svg">Scalable Vector Graphics</Tooltip>
    );

    const tooltipkx = <Tooltip id="tooltip-kx">Knowledge Exchange</Tooltip>;
    const tooltipqa = <Tooltip id="tooltip-qa">Quality Assurance</Tooltip>;

    const tooltippoc = <Tooltip id="tooltip-poc">Proof of Concept</Tooltip>;
    const modalClose = () => this.setState({ showFreeAccountModal: false });
    /* const upgrade = () => this.setState({ justUpgraded: true }); */
    return (
      <div>
        <EstimatorNavBar
          isAuthenticated={this.props.isAuthenticated}
          appLogout={this.props.appLogout}
          accountType={this.props.accountType}
          hideUpgradeLink={true}
        />
        <FreeAccountModal
          show={this.state.showFreeAccountModal}
          onHide={modalClose}
          estimatename={this.state.estimateName}
          history={this.props.history}
          estimatetosave={{
            estimateName: this.state.estimateName,
            totalFTE: this.state.totalFTE,
            //core content
            vendorObjectsS: this.state.vendorObjectsS,
            vendorObjectsM: this.state.vendorObjectsM,
            vendorObjectsC: this.state.vendorObjectsC,
            vendorTransformsS: this.state.vendorTransformsS,
            vendorTransformsM: this.state.vendorTransformsM,
            vendorTransformsC: this.state.vendorTransformsC,
            openSourceObjectsS: this.state.openSourceObjectsS,
            openSourceObjectsM: this.state.openSourceObjectsM,
            openSourceObjectsC: this.state.openSourceObjectsC,
            dataSourcesS: this.state.dataSourcesS,
            dataSourcesM: this.state.dataSourcesM,
            dataSourcesC: this.state.dataSourcesC,
            //app structure
            appsNumber: this.state.appsNumber,
            hierarchiesNumber: this.state.hierarchiesNumber,
            tabsNumber: this.state.tabsNumber,
            //project management
            hasManagement: this.state.hasManagement,
            hasBASupport: this.state.hasBASupport,
            isStrategicOrPoC: this.state.isStrategicOrPoC,
            hasSIT: this.state.hasSIT,
            hasUAT: this.state.hasUAT,
            hasKX: this.state.hasKX
          }}
        />
        <div className="NewEstimate">
          <Grid>
            <Col xs={12} md={8} className="padded-col">
              <form onSubmit={this.handleSubmit}>
                <Prompt
                  when={
                    !this.state.isLoading && !this.state.showFreeAccountModal
                  }
                  message={() =>
                    `Are you sure you want to leave this page? Your unsaved changes will be lost.`
                  }
                />

                <Row>
                  <FormGroup controlId="estimateName">
                    <ControlLabel>Estimate Name</ControlLabel>
                    <FormControl
                      onChange={this.handleChange}
                      value={this.state.estimateName}
                      type="text"
                      placeholder="e.g. My New Project"
                      required
                    />
                  </FormGroup>
                </Row>

                <Row>
                  <Tabs
                    activeKey={this.state.key}
                    onSelect={this.handleSelect}
                    id="input-tabs">
                    <Tab eventKey={1} title="Core Content">
                      <Col xs={12} md={12}>
                        <Row>
                          <Panel defaultExpanded>
                            <Panel.Heading>
                              <Panel.Title toggle>
                                <span>Vendor Objects/</span>
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={tooltipkpi}>
                                  <span className="tooltip-text">KPIs</span>
                                </OverlayTrigger>
                              </Panel.Title>
                            </Panel.Heading>
                            <Panel.Collapse>
                              <Panel.Body>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="vendorObjectsS">
                                    <ControlLabel>Simple</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.vendorObjectsS}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 4 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      Sum, Count, Average, etc.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="vendorObjectsM">
                                    <ControlLabel>Medium</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.vendorObjectsM}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 8 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      Set Analysis, Multi Date range comparison
                                      logic, alternate states.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="vendorObjectsC">
                                    <ControlLabel>Complex</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.vendorObjectsC}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 16 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      Set Analysis, Performance tuning, Direct
                                      Discovery,{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipodag}>
                                        <span className="tooltip-text">
                                          ODAG
                                        </span>
                                      </OverlayTrigger>
                                      , R Integration.
                                    </p>
                                  </FormGroup>
                                </Col>
                              </Panel.Body>
                            </Panel.Collapse>
                          </Panel>
                        </Row>
                        <Row>
                          <Panel defaultExpanded>
                            <Panel.Heading>
                              <Panel.Title toggle>
                                Vendor Transforms
                              </Panel.Title>
                            </Panel.Heading>
                            <Panel.Collapse>
                              <Panel.Body>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="vendorTransformsS">
                                    <ControlLabel>Simple</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.vendorTransformsS}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 2 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      1-2 related data sources with simple
                                      transformations i.e. not creating any new
                                      fields, single date field transposing.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="vendorTransformsM">
                                    <ControlLabel>Medium</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.vendorTransformsM}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 4 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      3-4 related data sources with more complex
                                      transformations e.g. creating calculated
                                      fields, multiple date field transposing.
                                      Creating mapping tables for data lookup
                                      during data loads.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="vendorTransformsC">
                                    <ControlLabel>Complex</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.vendorTransformsC}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 6 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      4+ data sources which may not be directly
                                      related and requires complex
                                      transformations. Involves pre-aggregating
                                      data or non-additive metrics, or a high
                                      volume of transformations across the whole
                                      data set.
                                    </p>
                                  </FormGroup>
                                </Col>
                              </Panel.Body>
                            </Panel.Collapse>
                          </Panel>
                        </Row>
                        <Row>
                          <Panel defaultExpanded>
                            <Panel.Heading>
                              <Panel.Title toggle>
                                Open-Source Objects
                              </Panel.Title>
                            </Panel.Heading>
                            <Panel.Collapse>
                              <Panel.Body>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="openSourceObjectsS">
                                    <ControlLabel>Simple</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.openSourceObjectsS}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 8 Hours
                                    </Label>
                                    <OverlayTrigger
                                      placement="bottom"
                                      overlay={tooltipjslibs}>
                                      <p>
                                        <br />
                                        Simple JavaScript charts e.g.
                                        <span className="tooltip-text">
                                          {' '}
                                          Chart.JS
                                        </span>
                                        , existing{' '}
                                        <span className="tooltip-text">
                                          D3.JS
                                        </span>{' '}
                                        object,{' '}
                                        <span className="tooltip-text">
                                          HighCharts
                                        </span>
                                        . Integrate a Vizlib visual into Qlik
                                        Sense with a complex data model. Using
                                        an extension from Qlik Branch.
                                      </p>
                                    </OverlayTrigger>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="openSourceObjectsM">
                                    <ControlLabel>Medium</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.openSourceObjectsM}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 40 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      Custom visualisation created using
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipsvg}>
                                        <span className="tooltip-text">
                                          {' '}
                                          SVG
                                        </span>
                                      </OverlayTrigger>{' '}
                                      and a JavaScript library like{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipjslibs}>
                                        <span className="tooltip-text">
                                          D3.JS
                                        </span>
                                      </OverlayTrigger>
                                      .
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="openSourceObjectsC">
                                    <ControlLabel>Complex</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.openSourceObjectsC}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 80 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      Complex bespoke object which requires
                                      extensive design effort as well as build
                                      and unit test effort.
                                    </p>
                                  </FormGroup>
                                </Col>
                              </Panel.Body>
                            </Panel.Collapse>
                          </Panel>
                        </Row>
                        <Row>
                          <Panel defaultExpanded>
                            <Panel.Heading>
                              <Panel.Title toggle>Data Sources</Panel.Title>
                            </Panel.Heading>
                            <Panel.Collapse>
                              <Panel.Body>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="dataSourcesS">
                                    <ControlLabel>Simple</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.dataSourcesS}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 4 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      Import from a spreadsheet or flat file or
                                      simple table
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="dataSourcesM">
                                    <ControlLabel>Medium</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.dataSourcesM}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 16 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      Import from a database with simple
                                      transformation logic. Includes some data
                                      analysis effort to identify keys and
                                      schema.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="dataSourcesC">
                                    <ControlLabel>Complex</ControlLabel>
                                    <FormControl
                                      onChange={this.handleChange}
                                      value={this.state.dataSourcesC}
                                      type="number"
                                      min="0"
                                    />
                                    <Label bsStyle="info">
                                      Unit Cost: 40 Hours
                                    </Label>
                                    <p>
                                      <br />
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipapi}>
                                        <span className="tooltip-text">
                                          API
                                        </span>
                                      </OverlayTrigger>{' '}
                                      integration, custom connector development,
                                      NOSQL/JSON development required.
                                    </p>
                                  </FormGroup>
                                </Col>
                              </Panel.Body>
                            </Panel.Collapse>
                          </Panel>
                        </Row>
                      </Col>
                    </Tab>
                    <Tab eventKey={2} title="App Struture">
                      <Col xs={12} md={12}>
                        <Row>
                          <Panel defaultExpanded>
                            <Panel.Body>
                              <Col xs={12} md={4}>
                                <FormGroup controlId="appsNumber">
                                  <ControlLabel>Apps</ControlLabel>
                                  <FormControl
                                    onChange={this.handleChange}
                                    value={this.state.appsNumber}
                                    type="number"
                                    min="0"
                                  />
                                  <Label bsStyle="info">Increment: 20%</Label>
                                  <p>
                                    <br />
                                    Additional effort for creating more apps,
                                    document linking, testing, version control,
                                    templates and project management.
                                  </p>
                                </FormGroup>
                              </Col>
                              <Col xs={12} md={4}>
                                <FormGroup controlId="hierarchiesNumber">
                                  <ControlLabel>Hierarchies</ControlLabel>
                                  <FormControl
                                    onChange={this.handleChange}
                                    value={this.state.hierarchiesNumber}
                                    type="number"
                                    min="0"
                                  />
                                  <Label bsStyle="info">Increment: 10%</Label>
                                  <p>
                                    <br />
                                    Custom drill down logic by date, Geospatial,
                                    custom aggregations not created
                                    automatically by Qlik’s associative engine.
                                  </p>
                                </FormGroup>
                              </Col>
                              <Col xs={12} md={4}>
                                <FormGroup controlId="tabsNumber">
                                  <ControlLabel>Tabs</ControlLabel>
                                  <FormControl
                                    onChange={this.handleChange}
                                    value={this.state.tabsNumber}
                                    type="number"
                                    min="0"
                                  />
                                  <Label bsStyle="info">Increment: 10%</Label>
                                  <p>
                                    <br />
                                    Additional effort for supporting multiple
                                    tabs, screens or sheets such as layouts,
                                    designs, menus.
                                  </p>
                                </FormGroup>
                              </Col>
                            </Panel.Body>
                          </Panel>
                        </Row>
                      </Col>
                    </Tab>
                    <Tab eventKey={3} title="Project Management">
                      <Col xs={12} md={12}>
                        <Row>
                          <Panel defaultExpanded>
                            <Panel.Body>
                              <Row>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="hasManagement">
                                    <ControlLabel>Management</ControlLabel>
                                    <FormControl
                                      componentClass="select"
                                      onChange={this.handleChange}
                                      value={this.state.hasManagement}
                                      type="number"
                                      min="0">
                                      <option value="1">Yes</option>
                                      <option value="0">No</option>
                                    </FormControl>
                                    <Label bsStyle="info">Increment: 30%</Label>
                                    <p>
                                      <br />
                                      Add effort for a project manager or scrum
                                      master to manage the project.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="hasBASupport">
                                    <ControlLabel>
                                      Business Analyst Support?
                                    </ControlLabel>
                                    <FormControl
                                      componentClass="select"
                                      onChange={this.handleChange}
                                      value={this.state.hasBASupport}
                                      type="number"
                                      min="0">
                                      <option value="1">Yes</option>
                                      <option value="0">No</option>
                                    </FormControl>
                                    <Label bsStyle="info">Increment: 10%</Label>
                                    <p>
                                      <br />
                                      Add time for a{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipba}>
                                        <span className="tooltip-text">BA</span>
                                      </OverlayTrigger>{' '}
                                      to run workshops and record either
                                      use-cases or requirements.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="isStrategicOrPoC">
                                    <ControlLabel>Strategic/PoC?</ControlLabel>
                                    <FormControl
                                      componentClass="select"
                                      onChange={this.handleChange}
                                      value={this.state.isStrategicOrPoC}
                                      type="number"
                                      min="0">
                                      <option value="1">Strategic</option>
                                      <option value="0">PoC</option>
                                    </FormControl>
                                    <Label bsStyle="info">Increment: 45%</Label>
                                    <p>
                                      <br />
                                      Adds effort if the application(s) will be
                                      put into production and have to go through
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipqa}>
                                        <span className="tooltip-text">
                                          {' '}
                                          QA
                                        </span>
                                      </OverlayTrigger>
                                      , regression testing, quality gates, etc.{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltippoc}>
                                        <span className="tooltip-text">
                                          PoC
                                        </span>
                                      </OverlayTrigger>{' '}
                                      does not add additional effort.
                                    </p>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="hasSIT">
                                    <ControlLabel>SIT?</ControlLabel>
                                    <FormControl
                                      componentClass="select"
                                      onChange={this.handleChange}
                                      value={this.state.hasSIT}
                                      type="number"
                                      min="0">
                                      <option value="1">Yes</option>
                                      <option value="0">No</option>
                                    </FormControl>
                                    <Label bsStyle="info">Increment: 20%</Label>
                                    <p>
                                      <br />
                                      Adds effort for{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipsit}>
                                        <span className="tooltip-text">
                                          SIT
                                        </span>
                                      </OverlayTrigger>{' '}
                                      with a wider team e.g.{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipetl}>
                                        <span className="tooltip-text">
                                          ETL{' '}
                                        </span>
                                      </OverlayTrigger>
                                      processes, IoT streaming, custom front end
                                      mashups, etc.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="hasUAT">
                                    <ControlLabel>UAT?</ControlLabel>
                                    <FormControl
                                      componentClass="select"
                                      onChange={this.handleChange}
                                      value={this.state.hasUAT}
                                      type="number"
                                      min="0">
                                      <option value="1">Yes</option>
                                      <option value="0">No</option>
                                    </FormControl>
                                    <Label bsStyle="info">Increment: 10%</Label>
                                    <p>
                                      <br />
                                      Adds effort for{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipuat}>
                                        <span className="tooltip-text">
                                          UAT
                                        </span>
                                      </OverlayTrigger>
                                      . Effort is for{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipba}>
                                        <span className="tooltip-text">BA</span>
                                      </OverlayTrigger>{' '}
                                      and test managers to run{' '}
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipuat}>
                                        <span className="tooltip-text">
                                          UAT
                                        </span>
                                      </OverlayTrigger>{' '}
                                      with business stakeholders and keep dev
                                      teams around to resolve bugs and changes.
                                    </p>
                                  </FormGroup>
                                </Col>
                                <Col xs={12} md={4}>
                                  <FormGroup controlId="hasKX">
                                    <ControlLabel>KX?</ControlLabel>
                                    <FormControl
                                      componentClass="select"
                                      onChange={this.handleChange}
                                      value={this.state.hasKX}
                                      type="number"
                                      min="0">
                                      <option value="1">Yes</option>
                                      <option value="0">No</option>
                                    </FormControl>
                                    <Label bsStyle="info">Increment:10%</Label>
                                    <p>
                                      <br />
                                      Effort to create a
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={tooltipkx}>
                                        <span className="tooltip-text">
                                          {' '}
                                          KX
                                        </span>
                                      </OverlayTrigger>{' '}
                                      between the project team and handing over
                                      to a support team. Focus is on
                                      documentation, training and handover.
                                    </p>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Panel.Body>
                          </Panel>
                        </Row>
                      </Col>
                    </Tab>
                  </Tabs>
                </Row>
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  className="btn-block"
                  onClick={e => this.nextTab(e)}>
                  {this.state.key === 3 ? 'Back to Core Content' : 'Next'}
                </Button>
                <LoaderButton
                  block
                  bsStyle="success"
                  bsSize="large"
                  disabled={!this.validateForm()}
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Save and Exit"
                  loadingText="Saving..."
                />
              </form>
              <p className="hint-text" hidden={this.validateForm()}>
                You must enter a project estimate name.
              </p>
            </Col>
            <Col xs={12} md={3} className="padded-col">
              <Row>
                <h1>Project Summary</h1>
              </Row>
              <Row>
                <Button onClick={e => this.takeScreenshot(e)}>
                  Generate Screenshot
                </Button>
              </Row>
              <Row>
                <a id="download-link" onClick={e => this.hideDownloadButton(e)}>
                  Download Link
                </a>
              </Row>

              <Row className="summary-row">
                <h4>
                  <Label bsStyle="primary">
                    Overall Total:{' '}
                    {(this.state.overallTotalHours / 8).toFixed(1)} Man Days
                  </Label>
                </h4>
                <FormGroup controlId="totalFTE">
                  <OverlayTrigger placement="bottom" overlay={tooltipfte}>
                    <FormGroup controlId="totalFTE">
                      <ControlLabel className="tooltip-text">
                        Total FTE
                      </ControlLabel>
                      <FormControl
                        onChange={this.handleChange}
                        value={this.state.totalFTE}
                        type="number"
                        min="0"
                      />
                    </FormGroup>
                  </OverlayTrigger>
                </FormGroup>
                <h2>
                  Estimated Duration:{' '}
                  <Label bsStyle="success">
                    {this.state.estimatedDuration.toFixed(1)} Months
                  </Label>
                </h2>
              </Row>
              <Row>
                <h3>Core Content Costs</h3>
                <Table striped bordered hover condensed responsive>
                  <tbody>
                    <tr>
                      <td>Vendor Objects</td>
                      <td>
                        {this.state.totalVendorObjectsHours.toFixed(1)} Hours
                      </td>
                    </tr>
                    <tr>
                      <td>Vendor Transforms</td>
                      <td>
                        {this.state.totalVendorTransformsHours.toFixed(1)} Hours
                      </td>
                    </tr>
                    <tr>
                      <td>Open-Source Objects</td>
                      <td>
                        {this.state.totalOpenSourceObjectsHours.toFixed(1)}{' '}
                        Hours
                      </td>
                    </tr>
                    <tr>
                      <td>Data Sources</td>
                      <td>
                        {this.state.totalDataSourcesHours.toFixed(1)} Hours
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <h4>
                  <Label bsStyle="primary">
                    Current Total: {this.state.coreContentHours} Hours/
                    {this.state.coreContentHours / 8} Man Days
                  </Label>
                </h4>
              </Row>
              <Row>
                <h3>App Structure Weighting</h3>
                <Table striped bordered hover condensed responsive>
                  <tbody>
                    <tr>
                      <td>Apps</td>
                      <td>{this.state.totalAppsHours.toFixed(1)} Hours</td>
                    </tr>
                    <tr>
                      <td>Hierarchies</td>
                      <td>
                        {this.state.totalHierarchiesHours.toFixed(1)} Hours
                      </td>
                    </tr>
                    <tr>
                      <td>Tabs</td>
                      <td>{this.state.totalTabsHours.toFixed(1)} Hours</td>
                    </tr>
                  </tbody>
                </Table>
                <h4>
                  <Label bsStyle="primary">
                    Current Total: {this.state.appStructureHours.toFixed(1)}{' '}
                    Hours/
                    {(this.state.appStructureHours / 8).toFixed(1)} Man Days
                  </Label>
                </h4>
              </Row>
              <Row>
                <h3>Project Management Costs</h3>
                <Table striped bordered hover condensed responsive>
                  <tbody>
                    <tr>
                      <td>Management</td>
                      <td>
                        {(this.state.totalManagementHours / 8).toFixed(1)} Man
                        Days
                      </td>
                    </tr>
                    <tr>
                      <OverlayTrigger placement="bottom" overlay={tooltipba}>
                        <td className="tooltip-text">BA Support</td>
                      </OverlayTrigger>
                      <td>
                        {(this.state.totalBASupportHours / 8).toFixed(1)} Man
                        Days
                      </td>
                    </tr>
                    <tr>
                      <td>Productionise</td>
                      <td>
                        {(this.state.totalStrategicOrPoCHours / 8).toFixed(1)}{' '}
                        Man Days
                      </td>
                    </tr>
                    <tr>
                      <OverlayTrigger placement="bottom" overlay={tooltipsit}>
                        <td className="tooltip-text">SIT</td>
                      </OverlayTrigger>
                      <td>
                        {(this.state.totalSITHours / 8).toFixed(1)} Man Days
                      </td>
                    </tr>
                    <tr>
                      <OverlayTrigger placement="bottom" overlay={tooltipuat}>
                        <td className="tooltip-text">UAT</td>
                      </OverlayTrigger>
                      <td>
                        {(this.state.totalUATHours / 8).toFixed(1)} Man Days
                      </td>
                    </tr>
                    <tr>
                      <OverlayTrigger placement="bottom" overlay={tooltipkx}>
                        <td className="tooltip-text">KX</td>
                      </OverlayTrigger>
                      <td>
                        {(this.state.totalKXHours / 8).toFixed(1)} Man Days
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <h4>
                  <Label bsStyle="primary">
                    Current Total:{' '}
                    {this.state.totalBeforeContingencyHours.toFixed(1)} Hours/
                    {(this.state.totalBeforeContingencyHours / 8).toFixed(
                      1
                    )}{' '}
                    Man Days
                  </Label>
                </h4>
              </Row>
              <Row>
                <Table striped bordered hover condensed responsive>
                  <tbody>
                    <tr>
                      <td>20% Contingency</td>
                      <td>
                        {(this.state.totalContingencyHours / 8).toFixed(1)} Man
                        Days
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Row>
            </Col>
          </Grid>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NewEstimate.js